const getTrimmedOrNull = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

export const getMeetingDescription = getTrimmedOrNull;

export const getMeetingJoinUrl = (joinUrl: string | null | undefined): string | null => {
  const trimmed = getTrimmedOrNull(joinUrl);
  if (!trimmed) return null;

  try {
    const { protocol } = new URL(trimmed);
    return protocol === 'https:' || protocol === 'http:' ? trimmed : null;
  } catch {
    return null;
  }
};

const JOIN_URL_HOSTS = [
  'teams.microsoft.com',
  'teams.microsoft.us',
  'teams.live.com',
  'zoom.us',
  'meet.google.com',
  'webex.com',
  'whereby.com',
  'chime.aws',
  'gotomeeting.com',
];

const URL_PATTERN = /https?:\/\/[^\s<>"'`]+/gi;
const TRAILING_PUNCTUATION = /[.,;:!?)\]}>'"]+$/;

const isJoinUrl = (url: string): boolean => {
  try {
    const { protocol, hostname } = new URL(url);
    if (protocol !== 'https:' && protocol !== 'http:') return false;

    const host = hostname.toLowerCase();
    return JOIN_URL_HOSTS.some((joinHost) => host === joinHost || host.endsWith(`.${joinHost}`));
  } catch {
    return false;
  }
};

export const extractMeetingJoinUrl = (description: string | null | undefined): string | null => {
  const text = getTrimmedOrNull(description);
  if (!text) return null;

  const matches = text.replace(/&amp;/gi, '&').match(URL_PATTERN) ?? [];

  for (const match of matches) {
    const url = match.replace(TRAILING_PUNCTUATION, '');
    if (isJoinUrl(url)) return url;
  }

  return null;
};
